import { z } from "zod";
import { optionalAddressSchema } from "./address";
import { MAX_LOGO_DATA_URL_LENGTH } from "./radiology";

/** Servicos oferecidos pelo laboratorio. */
export const LAB_SERVICES = [
  "EMAX",
  "ZIRCONIA",
  "PMMA",
  "RESINA_IMPRESSA",
  "UNITARIO",
  "FIXAS",
  "PROTOCOLOS",
  "ENCERAMENTO",
  "PLACA_BRUXISMO",
  "GUIA_IMPLANTE",
] as const;

export const labServiceSchema = z.enum(LAB_SERVICES);
export type LabService = z.infer<typeof labServiceSchema>;

export const LAB_SERVICE_LABELS: Record<LabService, string> = {
  EMAX: "Emax",
  ZIRCONIA: "Zircônia",
  PMMA: "Resina Fresada PMMA",
  RESINA_IMPRESSA: "Resina Impressa",
  UNITARIO: "Unitário",
  FIXAS: "Fixas",
  PROTOCOLOS: "Protocolos",
  ENCERAMENTO: "Enceramento de Diagnóstico",
  PLACA_BRUXISMO: "Placa de Bruxismo",
  GUIA_IMPLANTE: "Guia para Implante",
};

export const labSearchVisibilitySchema = z.enum(["PUBLIC", "PARTNERS_ONLY"]);
export type LabSearchVisibility = z.infer<typeof labSearchVisibilitySchema>;

export const updateLabProfileSchema = z.object({
  name: z.string().trim().max(120).nullable().optional(),
  services: z.array(labServiceSchema).default([]),
  logoUrl: z
    .string()
    .startsWith("data:image/")
    .max(MAX_LOGO_DATA_URL_LENGTH, "Imagem muito grande (max ~500KB)")
    .nullable()
    .optional(),
  addressSame: z.boolean().default(true),
  address: optionalAddressSchema.optional(),
  searchVisibility: labSearchVisibilitySchema.default("PUBLIC"),
  // Prazo padrão (dias). O perfil público não manda mais: o prazo é de Configurações › Dados
  // (setPrazoDeProducao). Ausente, o salvo fica como está — o padrão 7 sobrescrevia o prazo.
  slaDays: z.number().int().min(1).max(90).optional(),
});

export type UpdateLabProfileInput = z.infer<typeof updateLabProfileSchema>;
